var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"system-btn-common",on:{"click":function($event){return _vm.handleTo(_vm.item)}}},[_c('i',{staticClass:"icon iconfont",class:_vm.item.icon}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.item.title))]),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.item.desc))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }